module.exports = __webpack_public_path__ + "static/media/confirm.74f15891.svg";